import { useCallback } from 'react'
import { ifcRootGuid } from '@constants'
import DeleteIcon from '@mui/icons-material/Delete'
import { Button } from '@mui/material'
import { useControlStore } from '@editor/stores'
import { useDeleteDocument } from '@editorHooks'

interface Props {
  /** Called after the file has been successfully deleted. */
  onDeleted?: () => void
}

const IFCFileDeleteButton = ({ onDeleted }: Props) => {
  const activeIfcFileGuid = useControlStore(state => state.activeIfcFileGuid)
  const setActiveIfcFileGuid = useControlStore(state => state.setActiveIfcFileGuid)

  const { mutate: deleteFile, isLoading: isDeleting } = useDeleteDocument(ifcRootGuid, {
    onDeleteSuccess: () => {
      setActiveIfcFileGuid(null)
      onDeleted?.()
    },
  })

  const handleDelete = useCallback(() => {
    if (activeIfcFileGuid) {
      deleteFile(activeIfcFileGuid)
    }
  }, [activeIfcFileGuid, deleteFile])

  return (
    <Button
      variant="contained"
      color="error"
      size="small"
      startIcon={<DeleteIcon />}
      onClick={handleDelete}
      disabled={isDeleting}
    >
      {isDeleting ? 'Wird gelöscht…' : 'IFC-Datei löschen'}
    </Button>
  )
}

export default IFCFileDeleteButton
